// extracted by mini-css-extract-plugin
export default {"titleModal":"ModalInformation_titleModal__FHCWU","flexCenter":"ModalInformation_flexCenter__vKAPk","containerButton":"ModalInformation_containerButton__9qItc"};